import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { NonEmptyList, fromArrayMaybe } from 'nonempty-list';
import { T } from '../../../../../../../Translations';
import { OfferingType, getFullNameForOfferingType } from '../../../../../Types';

interface Props {
  omissions: NonEmptyList<OfferingType>;
}

function Omissions({ omissions }: Props) {
  return when(equals(omissions.length, 1), omissions)
    .map((oms) => <T kind={getFullNameForOfferingType(oms.first)} key={oms.first} />)
    .orElse(() =>
      when(equals(omissions.length, 2), {})
        .andThen(() => fromArrayMaybe(omissions.rest))
        .map((rest) => (
          <span key={omissions.first}>
            <T kind={getFullNameForOfferingType(omissions.first)} key={omissions.first} />{' '}
            <T kind="or" /> <T kind={getFullNameForOfferingType(rest.first)} key={rest.first} />
          </span>
        )),
    )
    .getOrElse(() => {
      const omissionJsx = omissions.toArray().map((omission, i) =>
        when(i < omissions.length - 1, {})
          .map(() => (
            <>
              <T kind={getFullNameForOfferingType(omission)} key={omission} />,{' '}
            </>
          ))
          .getOrElseValue(
            <span key={omission}>
              <T kind="or" key={`${omission}-or`} />{' '}
              <T kind={getFullNameForOfferingType(omission)} key={omission} />
            </span>,
          ),
      );
      return <span key="omission-jsx">{omissionJsx}</span>;
    });
}

export default observer(Omissions);
